import {
  apiDeleteMeter,
  apiPatchMeter,
  apiPostCancelMeter,
  apiPostMeter
} from '../../api/Argentia/endpoints/meters/meters.api'
import { CancelMeterModel, MeterModel } from '../../api/Argentia/model/contracts'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import { MeterModelPatch, MeterModelRequest } from './meters.model'

export const createMeter = async (
  newMeter: MeterModelRequest,
  cupsID: number
): Promise<ServiceResponse<MeterModel | undefined>> => {
  return apiPostMeter(newMeter, cupsID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateMeter = async (
  newMeter: MeterModelPatch
): Promise<ServiceResponse<MeterModel | undefined>> => {
  return apiPatchMeter(newMeter)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const cancelMeter = async (
  cancelMeter: CancelMeterModel
): Promise<ServiceResponse<CancelMeterModel | undefined>> => {
  return apiPostCancelMeter(cancelMeter)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteMeter = async (meterID: number): Promise<ServiceResponse<any>> => {
  return apiDeleteMeter(meterID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
